module.exports = "<div class=\"text-center animated fadeIn loading\">\n  <div>\n      <i class=\"fa fa-sync fa-spin fa-5x\"></i>\n  </div>\n</div>"